import { IMessage } from "../interfaces";
import { MESSAGE_LAYOUT, MESSAGE_STRUCTURE_TYPE } from "../enums";

/**
 * JIRA - SD-5915
 * Checks if the given value is a valid modal carousel or list message.
 *
 * JIRA: SD-7859
 * As part of incorporate the markdown message above the carousel. The modal layout carousel was broken.
 * So instead of depends on `index`, validating the structure dynamically type === MESSAGE_STRUCTURE_TYPE.Modal
 *
 * @param {IMessage} value - The message object to validate.
 * @returns {boolean} `true` if the message meets the criteria for being a modal carousel or list, otherwise `false`.
 */
export const isValidModalCarouselList = function (value: IMessage) {
	let isValid = false
	try {
		isValid = (value && value.contents && value.contents.layout &&
			(value.contents.layout === MESSAGE_LAYOUT.Carousel || value.contents.layout === MESSAGE_LAYOUT.List) &&
			Array.isArray(value.contents.structures) && value.contents.structures.some(({type}) => type === MESSAGE_STRUCTURE_TYPE.Modal));
	} catch (error) {
		console.log("'ClientApp/valid-modal-carousel.ts' - Error while parsing message object before validating it to exclude from computed property. value = ", value);
	}

	return isValid
};
